import { render } from "./SpiceLand.vue?vue&type=template&id=75186966"
import script from "./SpiceLand.vue?vue&type=script&lang=js"
export * from "./SpiceLand.vue?vue&type=script&lang=js"

import exportComponent from "/home/ec2-user/c2stem-server-spice/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__